import { useEffect, useState } from "react";
import axios from "axios";
import { Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FeaturedCar() {
  const [featured, setFeatured] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/featured`);
        if (data && data.id) setFeatured(data);
      } catch (e) {
        console.warn("No featured car set", e);
      }
    })();
  }, []);

  if (!featured) return null;

  const title = featured.featured_title || "This week's standout";
  const subtitle = featured.featured_subtitle || featured.label || "";
  const quote = featured.featured_quote || "";

  return (
    <section
      id="featured"
      data-testid="featured-section"
      className="relative bg-[#F5EBD9] py-20 lg:py-28 px-6 lg:px-12"
    >
      <div className="relative max-w-7xl mx-auto">
        <div className="mb-10 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#3D2E1C] text-[#D6B98D] rounded-full">
            <Sparkles className="w-3.5 h-3.5" strokeWidth={2} />
            <span className="text-xs font-bold uppercase tracking-wider">Car of the Week</span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-7 relative">
            <div className="absolute -inset-3 bg-[#D6B98D] rounded-3xl -rotate-2" />
            <div className="relative rounded-3xl overflow-hidden bg-white shadow-lg">
              <img
                src={`${API}/gallery/file/${featured.id}`}
                alt={title}
                data-testid="featured-image"
                className="w-full aspect-[4/3] object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-5">
            <h2
              data-testid="featured-title"
              className="font-serif text-4xl sm:text-5xl font-bold tracking-tight text-[#3D2E1C] leading-[1.1] mb-4"
            >
              {title}
            </h2>
            {subtitle && (
              <div
                data-testid="featured-subtitle"
                className="text-sm font-bold text-[#A67F4E] uppercase tracking-wider mb-5"
              >
                {subtitle}
              </div>
            )}
            {quote && (
              <blockquote
                data-testid="featured-quote"
                className="font-serif italic text-lg lg:text-xl text-[#3D2E1C]/80 border-l-4 border-[#D6B98D] pl-5"
              >
                &ldquo;{quote}&rdquo;
              </blockquote>
            )}
            <a
              href="#booking"
              data-testid="featured-book-link"
              className="mt-8 inline-flex items-center px-6 py-3.5 bg-[#3D2E1C] text-[#FDF9F3] hover:bg-[#A67F4E] text-sm font-bold rounded-full transition-all"
            >
              Book yours →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
